import React from 'react';

import { PartnerResultInfo, PartnerButton } from './';

export default function PartnerTab({ employee }) {
  return <div className="partner-tab"></div>;
}
